import(/* webpackMode: "eager" */ "/codebuild/output/src2552917822/src/app/global-error.tsx")